mutation updateLanguage($language: LanguageType, $auto: Boolean = false) {
  userEdit(language: $language, auto: $auto) {
    user {
      language
    }
  }
}
